const constants = {
    redColor: '#f44336',
    primaryColor: '#007aff',
    grayColor: '#767676',
    monthValidationErrorMessage: 'Please select a date range that does not exceed 3 months',
};

export default constants;
